/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Validation_Reason_LengthInputs */

const fr_validation_reason_length = /** @type {(inputs: Validation_Reason_LengthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saisissez un motif de 2 000 caractères maximum.`)
};

const en_validation_reason_length = /** @type {(inputs: Validation_Reason_LengthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter a reason of up to 2,000 characters.`)
};

/**
* | output |
* | --- |
* | "Enter a reason of up to 2,000 characters." |
*
* @param {Validation_Reason_LengthInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const validation_reason_length = /** @type {((inputs?: Validation_Reason_LengthInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Validation_Reason_LengthInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_validation_reason_length(inputs)
	return fr_validation_reason_length(inputs)
});